import { ReviewPostRepository } from '@/domain/repositories/reviewPost/reviewPostRepository'

export class PostReviewUseCase {
  constructor(private repository: ReviewPostRepository) {}

  async postReview(entryId: string, message: string, reviewerId: string): Promise<void> {
    try {
      await this.repository.postReview(entryId, message, reviewerId)
    } catch (error) {
      console.error(`Error in PostReviewUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
